// This is just an example,
// so you can safely delete all default props below

export default {
    back: 'Tilbake',
    delete_account: 'Slett konto',
    title: 'Er du sikker på at du vil slette din konto?',
    description: 'Dette sletter ikke din reisehistorikk.',
    failed: 'En feil har oppstått.'
}
